import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <main>
      <div className="container">
        <div style={{ marginTop: '120px', marginBottom: '50px' }}>
          <h1 className="section-title">Terms of Use</h1>
          
          <div style={{ marginTop: '30px', lineHeight: '1.6' }}>
            <p style={{ marginBottom: '20px' }}>
              Last Updated: April 1, 2025
            </p>
            
            <p style={{ marginBottom: '20px' }}>
              Welcome to Quick Flick. These Terms of Use govern your use of our service. By using, visiting, or registering for the Quick Flick service, 
              you accept and agree to these Terms. If you do not agree to these Terms, please do not use the service.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>1. The Quick Flick Service</h2>
            <p style={{ marginBottom: '15px' }}>
              The Quick Flick service provides a personalized subscription service that allows members to access movies and TV shows 
              ("Content") streamed over the Internet to certain Internet-connected devices ("Quick Flick ready devices").
            </p>
            <p style={{ marginBottom: '15px' }}>
              These Terms of Use govern your use of our service. As used in these Terms of Use, "Quick Flick service", "our service" or "the service" means 
              the personalized service provided by Quick Flick for discovering and watching Quick Flick content, including all features and functionalities, 
              website, and user interfaces, as well as all content and software associated with our service.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>2. Membership</h2>
            <p style={{ marginBottom: '15px' }}>
              2.1 Your Quick Flick membership continues until terminated. To use the Quick Flick service you must have Internet access and a Quick Flick ready device, 
              and provide a current, valid, accepted method of payment.
            </p>
            <p style={{ marginBottom: '15px' }}>
              2.2 We may offer a number of membership plans, including special promotional plans or memberships with differing conditions and limitations. 
              Any materially different terms will be disclosed at your sign-up or in other communications made available to you.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>3. Billing and Cancellation</h2>
            <p style={{ marginBottom: '15px' }}>
              3.1 Billing Cycle. The membership fee for the Quick Flick service will be charged to your payment method on the specific 
              payment date indicated on your "Account" page. The length of your billing cycle will depend on the type of subscription that you choose when 
              you signed up for the service.
            </p>
            <p style={{ marginBottom: '15px' }}>
              3.2 Payment Methods. You can change your payment method by accessing your account settings. If a payment is not successfully settled, due to 
              expiration, insufficient funds, or otherwise, and you do not change your payment method or cancel your account, we may suspend your access to the 
              service until we have obtained a valid payment method.
            </p>
            <p style={{ marginBottom: '15px' }}>
              3.3 Cancellation. You can cancel your Quick Flick membership at any time, and you will continue to have access to the service through the end 
              of your billing period. To cancel, go to the "Account" page and follow the instructions for cancellation.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>4. Quick Flick Service</h2>
            <p style={{ marginBottom: '15px' }}>
              4.1 You agree not to archive, reproduce, distribute, modify, display, perform, publish, license, create derivative works from, 
              offer for sale, or use content and information contained on or obtained from the Quick Flick service.
            </p>
            <p style={{ marginBottom: '15px' }}>
              4.2 We continually update the Quick Flick service, including the content library. In addition, we continually test various aspects of our service, 
              including our website, user interfaces, promotional features and availability of Quick Flick content.
            </p>
            <p style={{ marginBottom: '15px' }}>
              4.3 The availability of content will change from time to time. The quality of the display of the streaming content may vary from computer to 
              computer, and device to device, and may be affected by various factors, such as your location, the bandwidth available through and/or speed of your 
              Internet connection.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>5. Passwords & Account Access</h2>
            <p style={{ marginBottom: '15px' }}>
              5.1 The member who created the Quick Flick account and whose payment method is charged is considered the account owner. The account owner has 
              access and control over the Quick Flick account. The account owner's control is exercised through use of the account password and therefore to 
              maintain exclusive control, the account owner should not reveal the password to anyone.
            </p>
            <p style={{ marginBottom: '15px' }}>
              5.2 You are responsible for updating and maintaining the accuracy of the information you provide to us relating to your account. We can terminate 
              your account or place your account on hold in order to protect you, Quick Flick or our partners from identity theft or other fraudulent activity.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>6. Disclaimers of Warranties and Limitations on Liability</h2>
            <p style={{ marginBottom: '15px' }}>
              6.1 THE QUICK FLICK SERVICE AND ALL CONTENT AND SOFTWARE ASSOCIATED THEREWITH ARE PROVIDED "AS IS," WITH ALL FAULTS, WITH NO WARRANTIES 
              WHATSOEVER. QUICK FLICK EXPRESSLY DISCLAIMS ALL WARRANTIES, EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES 
              OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
            </p>
            <p style={{ marginBottom: '15px' }}>
              6.2 IN NO EVENT SHALL QUICK FLICK, OR ITS SUBSIDIARIES OR ANY OF THEIR SHAREHOLDERS, DIRECTORS, OFFICERS, EMPLOYEES OR LICENSORS BE LIABLE 
              FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES IN CONNECTION WITH OR OTHERWISE ARISING OUT OF THESE TERMS 
              OF USE.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>7. Governing Law</h2>
            <p style={{ marginBottom: '20px' }}>
              These Terms of Use shall be governed by and construed in accordance with the laws of the state of California, U.S.A. without regard to conflict 
              of laws provisions. These terms will not limit any consumer protection rights that you may be entitled to under the mandatory laws of your state 
              of residence.
            </p>
            
            <h2 style={{ fontSize: '1.5rem', margin: '30px 0 15px' }}>8. Changes to Terms of Use</h2>
            <p style={{ marginBottom: '20px' }}>
              Quick Flick may, from time to time, change these Terms of Use. We will notify you at least 30 days before these new Terms of Use apply to you.
            </p>
            
            <div style={{ 
              background: 'var(--secondary-color)',
              padding: '30px',
              borderRadius: '8px',
              marginTop: '40px'
            }}>
              <h2 style={{ marginBottom: '15px' }}>Contact Us</h2>
              <p style={{ marginBottom: '20px' }}>
                If you have any questions about these Terms of Use, please contact us at{' '}
                <a href="mailto:legal@quickflick.com" style={{ color: 'var(--primary-color)' }}>legal@quickflick.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TermsPage; 